'use client';

import { ErrorBoundary } from '@packages/shared/src/ui/ErrorBoundary/ErrorBoundary';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { type RawProductQuery } from '@packages/gql/generated/shopping/graphql';
import { useIntl } from 'react-intl';
import {
  useActiveSlide,
  useIsDialogOpen,
} from '../ImageGalleryProvider/ImageGalleryProvider.client';
import { ZoomDialog } from '../../ZoomDialog/ZoomDialog.client';
import { ErrorFallback } from '../../ZoomDialog/ErrorFallback/ErrorFallback.client';

type ImageGalleryZoomDialogWrapperProps = {
  media: NonNullable<RawProductQuery['product']>['media'];
  orderNumber: string;
};

export const ImageGalleryZoomDialogWrapper = ({
  media,
  orderNumber,
}: ImageGalleryZoomDialogWrapperProps) => {
  const { formatMessage } = useIntl();
  const [zoomDialogOpen, setZoomDialogOpen] = useIsDialogOpen();
  const [selectedIndex] = useActiveSlide();
  return (
    <>
      <Button
        onClick={() => setZoomDialogOpen(true)}
        className="bg-color-text-light h-5 w-5 touch-manipulation rounded-full border-none p-0 shadow-md"
        aria-label={formatMessage({
          id: 'imageGallery.aria.zoom',
          defaultMessage: 'Vollbildzoom öffnen',
        })}
      >
        <span className="icon-emp-enlarge size-4" />
      </Button>
      {zoomDialogOpen && (
        <ErrorBoundary
          fallback={(reset) => (
            <ErrorFallback
              onClose={() => {
                setZoomDialogOpen(false);
                reset();
              }}
            />
          )}
        >
          <ZoomDialog
            media={media}
            orderNumber={orderNumber}
            carouselIndex={selectedIndex}
            open={zoomDialogOpen}
            close={() => setZoomDialogOpen(false)}
          />
        </ErrorBoundary>
      )}
    </>
  );
};
